import React, { useState } from 'react'
import { withStyles } from '@material-ui/core'

const styles = {
  gridContainer: {
    display: 'flex',
    width: '96px',
    alignItems: 'center',
    alignContent: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  button: {
    borderRadius: 4,
    border: 'none',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    transition: 'all 0.3s',
    background: 'var(--mcg-bg, #F4F6F8)',
    color: '#3B82F6',
    '&:hover': {
      background: 'var(--mcg-bg, #F4F6F8)',
    },
  },
  activeButton: {
    background: 'var(--mcg-blue, #015FFB)',
    color: '#FFFFFF',
    '&:hover': {
      background: 'var(--mcg-blue, #015FFB)',
    },
  },
}

const CoreBackgroundPosition = ({ classes, onPositionChange, position }) => {
  const [currentPosition, setCurrentPosition] = useState(position)

  const positions = [
    { name: 'top-left', value: 'top left' },
    { name: 'top-center', value: 'top center' },
    { name: 'top-right', value: 'top right' },
    { name: 'center-left', value: 'center left' },
    { name: 'center', value: 'center' },
    { name: 'center-right', value: 'center right' },
    { name: 'bottom-left', value: 'bottom left' },
    { name: 'bottom-center', value: 'bottom center' },
    { name: 'bottom-right', value: 'bottom right' },
  ]

  const handlePositionChange = position => {
    setCurrentPosition(position)
    onPositionChange(position)
  }

  return (
    <div className={classes.gridContainer}>
      {positions.map(({ name, value }) => (
        <button
          key={name}
          className={`${classes.button} ${
            currentPosition === value ? classes.activeButton : ''
          }`}
          onClick={() => handlePositionChange(value)}
        ></button>
      ))}
    </div>
  )
}

export default withStyles(styles)(CoreBackgroundPosition)
